<template>
  <div v-if="isMobile" :data-testid="props.dataTestid"
    class="flex gap-4 overflow-x-auto hide-scroll-bar max-sm:px-4 mb-4 pt-4">
    <TsMedia v-for="item in props.data" :key="item.id" :append-class="`block min-w-max`">
      <TsMediaStart append-class="relative mr-0 mb-1">
        <TsImage v-if="item.image" :src="item.image" width="72" height="72" loading="lazy"/>
      </TsMediaStart>
      <TsMediaContent>
        <TsTypography variant="sm" align="center" append-class="max-w-[72px] mb-0 text-idle-black">
          {{ item.title }}
        </TsTypography>
      </TsMediaContent>
    </TsMedia>
  </div>
</template>

<script setup lang="ts">


const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const { isMobile } = useDevice();

type Props = {
  dataTestid?: string;
  data?: object[];
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ([
    {
      id: 1,
      image: '/images/deals.png',
      title: 'Deals'
    },
    {
      id: 2,
      image: '/images/electric-utility.png',
      title: 'Electric Utility'
    },
    {
      id: 3,
      image: '/images/electricity.png',
      title: 'Electricity'
    },
    {
      id: 4,
      image: '/images/hand-tool.png',
      title: 'Hand Tool'
    },
    {
      id: 5,
      image: '/images/screws-tools.png',
      title: 'Screws & Tools'
    },
    {
      id: 6,
      image: '/images/tools-accessories.webp',
      title: 'Tool Accessories'
    }
  ])
});
</script>